export default __webpack_public_path__ + "static/media/토스뱅크.4b0756ac.svg";